import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';
import React, { memo } from 'react';
import VideoPlayer from './video/videojs';

// const { isGalaxyZFold }: IBooleanArgs = useWidth();

const Video = ({
  isNoteSection = false,
  source,
  timeoutAction = false,
  tabChange = false,
  watermark = false,
  autoplay = true,
  videoJsOptions = {
    autoplay: autoplay,
    playbackRates: [0.5, 1, 1.25, 1.5, 2],
    controls: true,
    preload: 'auto',
    fluid: true,
    aspectRatio: '4:3',
    userActions: {
      hotkeys: true,
    },
    sources: [
      {
        src: source,
        type: 'video/mp4',
        label: '720P',
      },
      {
        src: source,
        type: 'video/mp4',
        label: '480P',
      },
      {
        src: source,
        type: 'video/mp4',
        label: '360P',
      },
    ],
  },
  onMouseEnter = null,
  onMouseLeave = null,
  customID = "",
  seekButtons = true,
  videoRef = React.useRef(null),
}) => {

  return (
    <div className="player" onContextMenu={e => e.preventDefault()}>
      <VideoPlayer
        options={videoJsOptions}
        timeoutAction={timeoutAction}
        // videoTime = {videoTime}
        watermark={watermark}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        // customID={customID}
        seekButtons={seekButtons}
        videoRef={videoRef}
      />
    </div>
  );
};

export default memo(Video);